<template>
  <v-menu offset-y class="w-100 d-block">
    <template v-slot:activator="{ on, attrs }">
      <div class="w-100">
        <button
          v-bind="attrs"
          v-on="on"
          class="btn btn--export-filter w-100 d-flex align-center justify-content-center btn-toolbar-action"
        >
          <span class="svg-icon me-1">
            <v-icon size="18">mdi-cloud-upload</v-icon>
          </span>
          <span>{{ $t("import") }}</span>
        </button>
      </div>
    </template>
    <v-list>
      <v-list-item v-for="(data, index) in types" :key="index">
        <v-list-item-title
          ><v-btn block @click="actionFunction(data.type)">{{
            data.name
          }}</v-btn></v-list-item-title
        >
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
// import Swal from "sweetalert2";
export default {
  name: "UploadSelectForASN",
  props: ["types", "actionFunction"],

  methods: {},
  computed: {},
};
</script>
